<div id="chat-animation-container" class="chat-container">
  <div id="chat-visualization" class="visualization-card" [ngClass]="{'is-mobile-view': isMobileView}">
      <!-- Main Visualization -->
      <div id="audio-visualization" class="visualization-area"  [ngClass]="{'is-mobile-view': isMobileView}" [class.paused]="!isRecording">
          <!-- Organic Shape Background -->
          <div class="organic-shape-container"  [ngClass]="{'is-mobile-view': isMobileView}" [class.paused]="!isRecording">
              <div class="organic-shape" [class.paused]="!isRecording"></div>
          </div>
          
          <!-- Consultant Image Container -->
          <div class="consultant-container"  [ngClass]="{'is-mobile-view': isMobileView}">
              <!-- Glowing Aura -->
              <div class="consultant-aura" [class.paused]="!isRecording"></div>
              
              <!-- Image Frame -->
              <div class="consultant-image-frame">
                  <!-- <img class="consultant-image" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/afcae687ca-240541b2627adf252c67.png" alt="professional female consultant portrait"> -->
                  <img class="consultant-image" [src]="imageRootFolder + 'consultant_chat.png'" alt="professional female consultant portrait">
              </div>
              
              <!-- Dynamic Audio Waves -->
              <div class="audio-particles-container">
                  <!-- Particle Audio Visualizer -->
                  <div class="particles-visualizer">
                      <div class="particles-group">
                          <!-- Floating Particles -->
                          <div class="particle particle-1" [class.paused]="!isPlaying"></div>
                          <div class="particle particle-2" [class.paused]="!isPlaying"></div>
                          <div class="particle particle-3" [class.paused]="!isPlaying"></div>
                          <div class="particle particle-4" [class.paused]="!isPlaying"></div>
                          <div class="particle particle-5" [class.paused]="!isPlaying"></div>
                          <div class="particle particle-6" [class.paused]="!isPlaying"></div>
                          <div class="particle particle-7" [class.paused]="!isPlaying"></div>
                      </div>
                      <!-- Connecting Lines -->
                      <div class="particles-connector" [class.paused]="!isPlaying"></div>
                  </div>
              </div>
          </div>

          <!-- Floating Elements -->
           <!-- @if(isPlaying || isRecording){ -->
            @if(true){
            <div class="floating-elements">
                <div class="floating-bubble bubble-1" [class.paused]="false"></div>
                <div class="floating-bubble bubble-2" [class.paused]="false"></div>
                
                <!-- Sparkles -->
                <div class="sparkle sparkle-1" [class.paused]="false"></div>
                <div class="sparkle sparkle-2" [class.paused]="false"></div>
                <div class="sparkle sparkle-3" [class.paused]="false"></div>
            </div>
          }

          @if(isProcessing){
          <div id="processing-overlay">
            <div class="overlay-content">
              <div class="relative-container">
                <div class="absolute-center">
                  <div class="spinner-container">
                    <div class="spinner-1"></div>
                    <div class="spinner-2"></div>
                    <div class="spinner-3"></div>
                    <div class="absolute-center">
                    </div>
                  </div>
                </div>
              </div>
              <div class="ping-container">
                <div class="ping-dot-rose"></div>
                <div class="ping-dot-amber"></div>
                <div class="ping-dot-purple"></div>
              </div>
            </div>
          </div>
          }
      </div>
  </div>
</div>

<style>
@keyframes morph {
  0%, 100% { border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; }
  50% { border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%; }
}
@keyframes particle {
  0%, 100% { transform: translateY(0) scale(0.8); opacity: 0.5; }
  50% { transform: translateY(-15px) scale(1.2); opacity: 1; }
}
@keyframes float {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, -20px) rotate(8deg); }
}
</style>